import React from "react";
import "../Css/Njs.css";

// import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";
import { NFooter } from "./NFooter";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const NHttp = () => {
  const [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div class="container-fluid background_node">
              <div className="row">
                <Navbar />
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/njslogo.png"}
                      width="85%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>

            <div
              class="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Node.js HTTP Module</h1>

                <div>
                  <p>
                    To make HTTP requests in Node.js, there is a built-in module
                    HTTP in Node.js to transfer data over the HTTP. To use the
                    HTTP server in node, we need to require the HTTP module. The
                    HTTP module creates an HTTP server that listens to server
                    ports and gives a response back to the client.
                  </p>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: To include the HTTP module, use the require() method:
                    <br />
                    var http = require('http');
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Node.js as a Web Server</h1>
                <p>
                  The HTTP module can create an HTTP server that listens to
                  server ports and gives a response back to the client. Use the
                  <span className="node-string"> createServer() </span> method
                  to create an HTTP server:
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6 mt-3" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    Example
                  </div>
                  <pre>
                    <code>
                      {`
                            var http = require('http');

                            //create a server object:
                            http.createServer(function (req, res) {
                              res.write('Hello World!'); //write a response to the client
                              res.end(); //end the response
                            }).listen(8080); //the server object listens on port 8080`}
                    </code>
                  </pre>
                  <br />
                  <p>
                    The function passed into the http.createServer() method,
                    will be executed when someone tries to access the computer
                    on port 8080.
                  </p>
                </div>
                <div className="col-md-3"></div>
                {/* <div className="bg-primary">
                  <p>
                    Note-: Step to run this program: Run index.js file using the
                    following command:
                    <br />
                    node index.js
                  </p>
                </div> */}
              </div>
              <hr style={{ color: "white" }} />
              <div className="row mt-5">
                <h1 className="py_h1">Read the Query String</h1>
                <p>
                  The function passed into the{" "}
                  <span className="node-string"> http.createServer() </span>has
                  a req argument that represents the request from the client, as
                  an object (http.IncomingMessage object).
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6 mt-3" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    Example
                  </div>
                  <pre>
                    <code>
                      {`
                            var http = require('http');
                            http.createServer(function (req, res) {
                              res.writeHead(200, {'Content-Type': 'text/html'});
                              res.write(req.url);
                              res.end();
                            }).listen(8080);
                            `}
                    </code>
                  </pre>
                  <br />
                  <p>
                    Save the code above in a file called "demo_http_url.js" and
                    initiate the file:
                  </p>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-5">
                <h1 className="py_h1">Split the Query String</h1>
                <p>
                  There are built-in modules to easily split the query string
                  into readable parts, such as the URL module.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6 mt-3" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    Example
                  </div>
                  <pre>
                    <code>
                      {`
                            var http = require('http');
                            var url = require('url');
                            
                            http.createServer(function (req, res) {
                              res.writeHead(200, {'Content-Type': 'text/html'});
                              var q = url.parse(req.url, true).query;
                              var txt = q.year + " " + q.month;
                              res.end(txt);
                            }).listen(8080);
                            `}
                    </code>
                  </pre>
                  <br />
                  <p>
                    Save the code above in a file called "demo_querystring.js"
                    and initiate the file:
                  </p>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <NFooter />
          </>
        )}
      </div>
    </>
  );
};
